import { action } from "typesafe-actions";

import { message } from "antd";

import { GatePayload, OrderingPayload, PaginatedResponse, PaginationPayload, SearchPayload } from "../common_types";

import {
  AirlinePayload,
  AirlineProductivityItem,
  AirlinesProductivityActionTypes,
  AirlinesProductivityPayload,
  DailyAirlineProductivityItem,
} from "./types";

export const airlinesProductivityFetchRequest = (
  payload: AirlinesProductivityPayload & SearchPayload & OrderingPayload & GatePayload & PaginationPayload
) => action(AirlinesProductivityActionTypes.TABLE_FETCH_REQUEST, payload);

export const airlinesProductivityFetchSuccess = (payload: PaginatedResponse<AirlineProductivityItem>) =>
  action(AirlinesProductivityActionTypes.TABLE_FETCH_SUCCESS, payload);

export const airlinesProductivityFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AirlinesProductivityActionTypes.TABLE_FETCH_ERROR);
};

export const dailyAirlinesProductivityFetchRequest = (payload: AirlinePayload & GatePayload) =>
  action(AirlinesProductivityActionTypes.DAILY_FETCH_REQUEST, payload);

export const dailyAirlinesProductivityFetchSuccess = (payload: {
  airline: string;
  items: DailyAirlineProductivityItem[];
}) => action(AirlinesProductivityActionTypes.DAILY_FETCH_SUCCESS, payload);

export const dailyAirlinesProductivityFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AirlinesProductivityActionTypes.DAILY_FETCH_ERROR);
};
